import utahGovLogo from './UtahGovLogo.html';
import renderDOM from "../misc/renderDOM";

export default function () {
	const logo = renderDOM(utahGovLogo);
	return logo;
}